import PropTypes from 'prop-types'

/**
 * Retrieves a node from a tree structure based on its ID.
 *
 * @param {Object|Array} tree - The tree structure to search in.
 * @param {string} _id - The ID of the node to retrieve.
 * @returns {Object|null} - The node with the specified ID, or null if not found.
 */
const getNodeById = (tree, _id) => {
  const nodes = Array.isArray(tree) ? tree : [tree]
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i]

    if (node._id === _id) {
      return node
    }
    if (node.children && typeof node.children === 'object') {
      const children = Object.values(node.children)
      const foundNode = getNodeById(children, _id)
      if (foundNode) return foundNode
    }
  }

  return null
}

getNodeById.propTypes = {
  tree: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  _id: PropTypes.string.isRequired
}

export default getNodeById
